import type { ExperimentKey } from './types';

export interface ShotPreset {
  id: string;
  order: number;
  exp: ExperimentKey;
  adv?: boolean;
}

/**
 * One screenshot pose per experiment.
 * id === experiment key; order drives the filename prefix.
 * The platform spec iterates this array and navigates to
 * /{slug}/index.html?shot={id}&theme={theme}.
 */
export const SHOT_PRESETS: readonly ShotPreset[] = [
  { id: 'compound-interest', order: 1, exp: 'compound-interest' },
  { id: 'power-of-time', order: 2, exp: 'power-of-time' },
  { id: 'savings-goal', order: 3, exp: 'savings-goal', adv: true },
  { id: 'borrowing-cost', order: 4, exp: 'borrowing-cost' },
  { id: 'inflation', order: 5, exp: 'inflation' },
  { id: 'fees-drag', order: 6, exp: 'fees-drag' },
];
